module.exports = __webpack_public_path__ + "images/emoji/japan.86a10a95985bc7ea757d.png";